const GET_USER_INFO_PATH = '/lt-web/xs/user/getUserInfo'

/** 仅记录客服核身实名接口，避免给其他业务请求增加无关日志。 */
function isCustomerServiceGetUserInfo (config = {}) {
  const search = typeof location === 'undefined' ? '' : location.search
  return search.includes('purpose=customerService') && String(config.url || '').includes(GET_USER_INFO_PATH)
}

/** 敏感登录字段只记录是否存在、长度和末四位，便于跨容器比对而不暴露完整值。 */
function summarizeSecret (value) {
  const text = value == null ? '' : String(value)
  return {
    present: Boolean(text),
    length: text.length,
    tail: text ? text.slice(-4) : ''
  }
}

/** AxiosHeaders 和普通对象在不同构建环境下都转换为可读取对象。 */
function normalizeHeaders (headers) {
  if (!headers) return {}
  return typeof headers.toJSON === 'function' ? headers.toJSON() : headers
}

/** appInfo 可能是请求头 JSON 字符串，解析失败时保留明确诊断标记。 */
function summarizeAppInfo (rawAppInfo) {
  try {
    const appInfo = typeof rawAppInfo === 'string' ? JSON.parse(rawAppInfo) : (rawAppInfo || {})
    return {
      pkgName: appInfo.pkgName || '',
      appVersion: appInfo.appVersion || '',
      channel: appInfo.channel || ''
    }
  } catch (error) {
    return { invalid: true }
  }
}

/** 请求拦截器完成公共参数拼装后记录最终请求快照，用于定位 App WebView 差异。 */
export function logCustomerServiceGetUserInfoRequest (config) {
  if (!isCustomerServiceGetUserInfo(config)) return
  const headers = normalizeHeaders(config.headers)
  const data = config.data || {}
  console.log('[客服核身][getUserInfo][请求]', {
    time: new Date().toISOString(),
    page: `${location.origin}${location.pathname}`,
    requestUrl: `${config.baseURL || ''}${config.url || ''}`,
    lzCode: headers.lzCode || '',
    linktoken: headers.linktoken || '',
    appInfo: summarizeAppInfo(headers.appInfo),
    headerToken: summarizeSecret(headers.token),
    bodyToken: summarizeSecret(data.token),
    bodyUserName: summarizeSecret(data.userName),
    hasEnvData: Boolean(data.envData),
    hasSign: Boolean(data.sign)
  })
}

/** 业务失败也属于 HTTP 200，因此单独记录后端 code/msg 和请求地址。 */
export function logCustomerServiceGetUserInfoResponse (response) {
  if (!isCustomerServiceGetUserInfo(response && response.config)) return
  console.log('[客服核身][getUserInfo][响应]', {
    time: new Date().toISOString(),
    requestUrl: `${response.config.baseURL || ''}${response.config.url || ''}`,
    httpStatus: response.status,
    code: response.data && response.data.code,
    msg: response.data && response.data.msg
  })
}

/** 网络层失败没有业务响应时仍保留 HTTP 状态和异常信息。 */
export function logCustomerServiceGetUserInfoError (error) {
  const config = error && error.config
  if (!isCustomerServiceGetUserInfo(config)) return
  console.log('[客服核身][getUserInfo][异常]', {
    time: new Date().toISOString(),
    requestUrl: `${config.baseURL || ''}${config.url || ''}`,
    httpStatus: error.response && error.response.status,
    message: error.message || ''
  })
}
